import { render, staticRenderFns } from "./ReconocimientosForm.vue?vue&type=template&id=714a9ad4"
import script from "./ReconocimientosForm.vue?vue&type=script&lang=js"
export * from "./ReconocimientosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports